"use client";

import { Toaster as Sonner, toast } from "sonner";

export const Toaster = (props: any) => {
  return (
    <Sonner
      theme="light"
      position="top-center"
      closeButton
      {...props}
    />
  );
};

export { toast };
